/**
 * DevExtreme (esm/ui/data_grid/ui.data_grid.validating.js)
 * Version: 21.2.14
 * Build date: Tue Jun 20 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import gridCore from "./ui.data_grid.core";
import {
    validatingModule
} from "../grid_core/ui.grid_core.validating";
gridCore.registerModule("validating", validatingModule);
